/**
 * External Reference Parsing Mode
 *
 * Controls how strict the parser should be when validating external booking references.
 */
export enum EExternalReferenceParsingMode {
  /**
   * Soft Mode (Default) - Forgiving parser for real-world data
   *
   * Features:
   * - Accepts concatenated formats: ABCD123LI
   * - Accepts spaced formats: ABCD123 LI, ABCD123 / LI
   * - Accepts legacy non-mission: "Maintenance", "Validity Check", etc.
   * - Accepts full organ names: Liver, Heart, Lungs, Lung, Kidney
   * - Accepts various separators: /, -, no separator
   * - Forgiving with spacing and capitalization
   * - Multi-organ: extracts all, returns first, logs warning
   * - Extracts what it can from messy data
   *
   * Use for: Production environments, user-entered data, legacy migrations
   */
  Soft = 'soft',

  /**
   * Strict Mode - Enforces new format standards
   *
   * Features:
   * - Enforces exact new format requirements:
   *   * Maintenance: "MX / [info]"
   *   * Training: "TRNG / [info]"
   *   * Reposition: "Repo / [info]"
   *   * Special: "Special / [info]"
   *   * Mission: "UNOSID[ORGAN] / [Info]" OR "UNOSID [ORGAN] / [Info]"
   * - Rejects multi-organ flights (error logged)
   * - Rejects ambiguous or malformed entries
   * - Requires proper formatting and separators
   *
   * Use for: Data validation, new entry validation, API input verification
   */
  Strict = 'strict',
}
